/* @generated */
// prettier-ignore
if (Intl.DisplayNames && typeof Intl.DisplayNames.__addLocaleData === 'function') {
  Intl.DisplayNames.__addLocaleData({
  "data": {
    "patterns": {
      "locale": "{0} ({1})"
    },
    "types": {
      "calendar": {
        "long": {
          "buddhist": "buddhist",
          "chinese": "chinese",
          "coptic": "coptic",
          "dangi": "dangi",
          "ethiopic": "ethiopic",
          "ethiopic-amete-alem": "ethiopic-amete-alem",
          "gregorian": "גרעגארישער קאַלענדאַר",
          "hebrew": "hebrew",
          "indian": "indian",
          "islamic": "islamic",
          "islamic-civil": "islamic-civil",
          "islamic-rgsa": "islamic-rgsa",
          "islamic-tbla": "islamic-tbla",
          "islamic-umalqura": "islamic-umalqura",
          "iso8601": "iso8601",
          "japanese": "japanese",
          "persian": "persian",
          "roc": "roc"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "currency": {
        "long": {
          "ADP": "ADP",
          "AED": "AED",
          "AFA": "AFA",
          "AFN": "AFN",
          "ALK": "ALK",
          "ALL": "ALL",
          "AMD": "AMD",
          "ANG": "ANG",
          "AOA": "AOA",
          "AOK": "AOK",
          "AON": "AON",
          "AOR": "AOR",
          "ARA": "ARA",
          "ARL": "ARL",
          "ARM": "ARM",
          "ARP": "ARP",
          "ARS": "ARS",
          "ATS": "ATS",
          "AUD": "AUD",
          "AWG": "AWG",
          "AZM": "AZM",
          "AZN": "AZN",
          "BAD": "BAD",
          "BAM": "BAM",
          "BAN": "BAN",
          "BBD": "BBD",
          "BDT": "BDT",
          "BEC": "BEC",
          "BEF": "BEF",
          "BEL": "BEL",
          "BGL": "BGL",
          "BGM": "BGM",
          "BGN": "BGN",
          "BGO": "BGO",
          "BHD": "BHD",
          "BIF": "BIF",
          "BMD": "BMD",
          "BND": "BND",
          "BOB": "BOB",
          "BOL": "BOL",
          "BOP": "BOP",
          "BOV": "BOV",
          "BRB": "BRB",
          "BRC": "BRC",
          "BRE": "BRE",
          "BRL": "בראזיל רעאל",
          "BRN": "BRN",
          "BRR": "BRR",
          "BRZ": "BRZ",
          "BSD": "BSD",
          "BTN": "BTN",
          "BUK": "BUK",
          "BWP": "BWP",
          "BYB": "BYB",
          "BYN": "BYN",
          "BYR": "BYR",
          "BZD": "בעליז דאלאַר",
          "CAD": "CAD",
          "CDF": "CDF",
          "CHE": "CHE",
          "CHF": "שווייצער פֿראַנק",
          "CHW": "CHW",
          "CLE": "CLE",
          "CLF": "CLF",
          "CLP": "CLP",
          "CNH": "CNH",
          "CNX": "CNX",
          "CNY": "כינעזישער יואן",
          "COP": "COP",
          "COU": "COU",
          "CRC": "CRC",
          "CSD": "CSD",
          "CSK": "CSK",
          "CUC": "CUC",
          "CUP": "CUP",
          "CVE": "CVE",
          "CYP": "CYP",
          "CZK": "CZK",
          "DDM": "DDM",
          "DEM": "DEM",
          "DJF": "DJF",
          "DKK": "DKK",
          "DOP": "DOP",
          "DZD": "DZD",
          "ECS": "ECS",
          "ECV": "ECV",
          "EEK": "EEK",
          "EGP": "EGP",
          "ERN": "ERN",
          "ESA": "ESA",
          "ESB": "ESB",
          "ESP": "ESP",
          "ETB": "ETB",
          "EUR": "איירא",
          "FIM": "FIM",
          "FJD": "FJD",
          "FKP": "FKP",
          "FRF": "FRF",
          "GBP": "פֿונט שטערלינג",
          "GEK": "GEK",
          "GEL": "GEL",
          "GHC": "GHC",
          "GHS": "GHS",
          "GIP": "GIP",
          "GMD": "GMD",
          "GNF": "GNF",
          "GNS": "GNS",
          "GQE": "GQE",
          "GRD": "GRD",
          "GTQ": "GTQ",
          "GWE": "GWE",
          "GWP": "GWP",
          "GYD": "GYD",
          "HKD": "HKD",
          "HNL": "HNL",
          "HRD": "HRD",
          "HRK": "HRK",
          "HTG": "HTG",
          "HUF": "HUF",
          "IDR": "IDR",
          "IEP": "IEP",
          "ILP": "ILP",
          "ILR": "ILR",
          "ILS": "ILS",
          "INR": "אינדישער רופי",
          "IQD": "IQD",
          "IRR": "IRR",
          "ISJ": "ISJ",
          "ISK": "ISK",
          "ITL": "ITL",
          "JMD": "JMD",
          "JOD": "JOD",
          "JPY": "יאפאנעזישער יען",
          "KES": "KES",
          "KGS": "KGS",
          "KHR": "KHR",
          "KMF": "KMF",
          "KPW": "KPW",
          "KRH": "KRH",
          "KRO": "KRO",
          "KRW": "KRW",
          "KWD": "KWD",
          "KYD": "KYD",
          "KZT": "KZT",
          "LAK": "LAK",
          "LBP": "LBP",
          "LKR": "LKR",
          "LRD": "LRD",
          "LSL": "LSL",
          "LTL": "LTL",
          "LTT": "LTT",
          "LUC": "LUC",
          "LUF": "LUF",
          "LUL": "LUL",
          "LVL": "LVL",
          "LVR": "LVR",
          "LYD": "LYD",
          "MAD": "MAD",
          "MAF": "MAF",
          "MCF": "MCF",
          "MDC": "MDC",
          "MDL": "MDL",
          "MGA": "MGA",
          "MGF": "MGF",
          "MKD": "MKD",
          "MKN": "MKN",
          "MLF": "MLF",
          "MMK": "MMK",
          "MNT": "MNT",
          "MOP": "MOP",
          "MRO": "MRO",
          "MRU": "MRU",
          "MTL": "MTL",
          "MTP": "MTP",
          "MUR": "MUR",
          "MVP": "MVP",
          "MVR": "MVR",
          "MWK": "MWK",
          "MXN": "MXN",
          "MXP": "MXP",
          "MXV": "MXV",
          "MYR": "MYR",
          "MZE": "MZE",
          "MZM": "MZM",
          "MZN": "MZN",
          "NAD": "NAD",
          "NGN": "NGN",
          "NIC": "NIC",
          "NIO": "NIO",
          "NLG": "NLG",
          "NOK": "NOK",
          "NPR": "NPR",
          "NZD": "NZD",
          "OMR": "OMR",
          "PAB": "PAB",
          "PEI": "PEI",
          "PEN": "PEN",
          "PES": "PES",
          "PGK": "PGK",
          "PHP": "PHP",
          "PKR": "PKR",
          "PLN": "PLN",
          "PLZ": "PLZ",
          "PTE": "PTE",
          "PYG": "PYG",
          "QAR": "QAR",
          "RHD": "RHD",
          "ROL": "ROL",
          "RON": "RON",
          "RSD": "RSD",
          "RUB": "רוסישער רובל",
          "RUR": "RUR",
          "RWF": "RWF",
          "SAR": "SAR",
          "SBD": "SBD",
          "SCR": "SCR",
          "SDD": "SDD",
          "SDG": "SDG",
          "SDP": "SDP",
          "SEK": "שוועדישע קראנע",
          "SGD": "SGD",
          "SHP": "SHP",
          "SIT": "SIT",
          "SKK": "SKK",
          "SLL": "SLL",
          "SOS": "SOS",
          "SRD": "SRD",
          "SRG": "SRG",
          "SSP": "SSP",
          "STD": "STD",
          "STN": "STN",
          "SUR": "SUR",
          "SVC": "SVC",
          "SYP": "SYP",
          "SZL": "SZL",
          "THB": "THB",
          "TJR": "TJR",
          "TJS": "TJS",
          "TMM": "TMM",
          "TMT": "TMT",
          "TND": "TND",
          "TOP": "TOP",
          "TPE": "TPE",
          "TRL": "TRL",
          "TRY": "TRY",
          "TTD": "TTD",
          "TWD": "TWD",
          "TZS": "TZS",
          "UAH": "UAH",
          "UAK": "UAK",
          "UGS": "UGS",
          "UGX": "UGX",
          "USD": "אמעריקאנער דאלאר",
          "USN": "USN",
          "USS": "USS",
          "UYI": "UYI",
          "UYP": "UYP",
          "UYU": "UYU",
          "UYW": "UYW",
          "UZS": "UZS",
          "VEB": "VEB",
          "VEF": "VEF",
          "VES": "VES",
          "VND": "VND",
          "VNN": "VNN",
          "VUV": "VUV",
          "WST": "WST",
          "XAF": "XAF",
          "XAG": "זילבער",
          "XAU": "גאלד",
          "XBA": "XBA",
          "XBB": "XBB",
          "XBC": "XBC",
          "XBD": "XBD",
          "XCD": "XCD",
          "XDR": "XDR",
          "XEU": "XEU",
          "XFO": "XFO",
          "XFU": "XFU",
          "XOF": "XOF",
          "XPD": "XPD",
          "XPF": "XPF",
          "XPT": "XPT",
          "XRE": "XRE",
          "XSU": "XSU",
          "XTS": "XTS",
          "XUA": "XUA",
          "XXX": "אומבאַוואוסטע וואַלוטע",
          "YDD": "YDD",
          "YER": "YER",
          "YUD": "YUD",
          "YUM": "YUM",
          "YUN": "YUN",
          "YUR": "YUR",
          "ZAL": "ZAL",
          "ZAR": "ZAR",
          "ZMK": "ZMK",
          "ZMW": "ZMW",
          "ZRN": "ZRN",
          "ZRZ": "ZRZ",
          "ZWD": "ZWD",
          "ZWL": "ZWL",
          "ZWR": "ZWR"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "dateTimeField": {
        "long": {
          "day": "טאָג",
          "dayOfYear": "Day Of Year",
          "dayperiod": "Dayperiod",
          "era": "תקופֿה",
          "hour": "שעה",
          "minute": "מינוט",
          "month": "מאנאַט",
          "quarter": "Quarter",
          "second": "סעקונדע",
          "timeZoneName": "צײַטזאנע",
          "weekOfMonth": "Week Of Month",
          "weekOfYear": "וואך",
          "weekday": "טאָג אין דער וואך",
          "weekdayOfMonth": "Weekday Of Month",
          "year": "יאָר"
        },
        "narrow": {
          "day": "טאָג",
          "dayOfYear": "Day Of Year",
          "dayperiod": "Dayperiod",
          "era": "תקופֿה",
          "hour": "שעה",
          "minute": "מינוט",
          "month": "מאנאַט",
          "quarter": "Quarter",
          "second": "סעקונדע",
          "timeZoneName": "צײַטזאנע",
          "weekOfMonth": "Week Of Month",
          "weekOfYear": "וואך",
          "weekday": "טאָג אין דער וואך",
          "weekdayOfMonth": "Weekday Of Month",
          "year": "יאָר"
        },
        "short": {
          "day": "טאָג",
          "dayOfYear": "Day Of Year",
          "dayperiod": "Dayperiod",
          "era": "תקופֿה",
          "hour": "שעה",
          "minute": "מינוט",
          "month": "מאנאַט",
          "quarter": "Quarter",
          "second": "סעקונדע",
          "timeZoneName": "צײַטזאנע",
          "weekOfMonth": "Week Of Month",
          "weekOfYear": "וואך",
          "weekday": "טאָג אין דער וואך",
          "weekdayOfMonth": "Weekday Of Month",
          "year": "יאָר"
        }
      },
      "language": {
        "dialect": {
          "long": {
            "aa": "אַפֿאַר",
            "ab": "ab",
            "af": "אַפֿריקאַנס",
            "agq": "agq",
            "ak": "ak",
            "akk": "אַקאַדיש",
            "am": "אַמהאַריש",
            "an": "אַראַגאניש",
            "ang": "אַלט ענגליש",
            "ar": "אַראַביש",
            "ar-001": "אַראַביש (וועלט)",
            "arc": "אַראַמיש",
            "as": "אַסאַמיש",
            "asa": "asa",
            "ast": "ast",
            "az": "אַזערביידזשאַניש",
            "ban": "באַלינעזיש",
            "bar": "בײַעריש",
            "bas": "bas",
            "be": "בעלאַרוסיש",
            "bem": "bem",
            "bez": "bez",
            "bg": "בולגאַריש",
            "bm": "bm",
            "bn": "בענגאַליש",
            "bo": "טיבעטיש",
            "br": "ברעטאניש",
            "brx": "brx",
            "bs": "באסניש",
            "ca": "קאַטאַלאניש",
            "ccp": "ccp",
            "ce": "ce",
            "ceb": "סעבואַניש",
            "cgg": "cgg",
            "chr": "chr",
            "ckb": "ckb",
            "co": "co",
            "crh": "קרים־טערקיש",
            "cs": "טשעכיש",
            "csb": "קאַשוביש",
            "cu": "קלויסטער־סלאַוויש",
            "cy": "וועלשיש",
            "da": "דעניש",
            "dav": "dav",
            "de": "דײַטש",
            "de-AT": "דײַטש (עסטרייך)",
            "de-CH": "דײַטש (שווייץ)",
            "dje": "dje",
            "doi": "doi",
            "dsb": "אונטער־סארביש",
            "dua": "dua",
            "dyo": "זשאלא־פֿאני",
            "dz": "dz",
            "ebu": "ebu",
            "ee": "ee",
            "el": "גריכיש",
            "en": "ענגליש",
            "en-AU": "ענגליש (אויסטראַליע)",
            "en-CA": "ענגליש (קאַנאַדע)",
            "en-GB": "ענגליש (פֿאַראייניגטע קעניגרייך)",
            "en-US": "ענגליש (פֿאַראייניגטע שטאַטן)",
            "enm": "מיטל ענגליש",
            "eo": "עספּעראַנטא",
            "es": "שפּאַניש",
            "es-419": "שפּאַניש (לאַטיין־אַמעריקע)",
            "es-ES": "שפּאַניש (שפּאַניע)",
            "es-MX": "שפּאַניש (מעקסיקע)",
            "et": "עסטיש",
            "eu": "באַסקיש",
            "ewo": "ewo",
            "fa": "פּערסיש",
            "fa-AF": "פּערסיש (אַפֿגהאַניסטאַן)",
            "ff": "ff",
            "fi": "פֿיניש",
            "fil": "פֿיליפּינא",
            "fj": "פֿידזשי",
            "fo": "פֿאַראיש",
            "fr": "פֿראַנצויזיש",
            "fr-CA": "פֿראַנצויזיש (קאַנאַדע)",
            "fr-CH": "פֿראַנצויזיש (שווייץ)",
            "frc": "frc",
            "fro": "אַלט־פֿראַנצויזיש",
            "frr": "דרום־פֿריזיש",
            "frs": "מזרח־פֿריזיש",
            "fur": "fur",
            "fy": "מערב־פֿריזיש",
            "ga": "איריש",
            "gd": "סקאטיש געליש",
            "gl": "גאַלישיש",
            "gmh": "מיטל הויכדויטש",
            "goh": "אַלט־ הויכדויטש",
            "got": "גאטיש",
            "grc": "אוראַלט־גריכיש",
            "gsw": "gsw",
            "gu": "gu",
            "guz": "guz",
            "gv": "מאַנקס",
            "ha": "האַוסאַ",
            "haw": "haw",
            "he": "העברעאיש",
            "hi": "הינדי",
            "hif": "פידזשי הינדי",
            "hmn": "hmn",
            "hr": "קראאַטיש",
            "hsb": "אייבער־סארביש",
            "ht": "ht",
            "hu": "אונגעריש",
            "hy": "אַרמעניש",
            "ia": "ia",
            "id": "אינדאנעזיש",
            "ig": "ig",
            "ii": "ii",
            "io": "אידא",
            "is": "איסלאַנדיש",
            "it": "איטאַליעניש",
            "ja": "יאַפּאַניש",
            "jbo": "לאזשבאָן",
            "jgo": "jgo",
            "jmc": "jmc",
            "jpr": "יידיש־פערסיש",
            "jv": "יאַוואַנעזיש",
            "ka": "גרוזיניש",
            "kab": "kab",
            "kam": "kam",
            "kde": "kde",
            "kea": "kea",
            "kgp": "kgp",
            "khq": "khq",
            "ki": "ki",
            "kk": "קאַזאַכיש",
            "kkj": "kkj",
            "kl": "kl",
            "kln": "kln",
            "km": "כמער",
            "kn": "קאַנאַדאַ",
            "ko": "קארעאיש",
            "kok": "kok",
            "ks": "ks",
            "ksb": "ksb",
            "ksf": "ksf",
            "ksh": "ksh",
            "ku": "קורדיש",
            "kw": "קארניש",
            "ky": "קירגיזיש",
            "la": "לאטייניש",
            "lad": "לאַדינא",
            "lag": "lag",
            "lb": "לוקסעמבורגיש",
            "lg": "lg",
            "lij": "lij",
            "liv": "ליוויש",
            "lkt": "lkt",
            "ln": "ln",
            "lo": "לאַא",
            "lou": "lou",
            "lrc": "lrc",
            "lt": "ליטוויש",
            "lu": "lu",
            "luo": "luo",
            "lus": "מיזא",
            "luy": "luy",
            "lv": "לעטיש",
            "mai": "mai",
            "mas": "mas",
            "mer": "mer",
            "mfe": "mfe",
            "mg": "mg",
            "mgh": "mgh",
            "mgo": "mgo",
            "mi": "מאַאריש",
            "mk": "מאַקעדאניש",
            "ml": "מאַלאַיאַלאַם",
            "mn": "מאנגאליש",
            "mni": "mni",
            "mr": "mr",
            "ms": "ms",
            "mt": "מאַלטעזיש",
            "mua": "mua",
            "mul": "mul",
            "my": "בירמאַניש",
            "mzn": "mzn",
            "nap": "נאַפּאליטַניש",
            "naq": "naq",
            "nb": "nb",
            "nd": "nd",
            "nds": "נידערדײַטש",
            "nds-NL": "נידערדײַטש (האלאַנד)",
            "ne": "נעפּאַליש",
            "nl": "האלענדיש",
            "nl-BE": "פֿלעמיש",
            "nmg": "nmg",
            "nn": "נײַ־נארוועגיש",
            "nnh": "nnh",
            "no": "נארוועגיש",
            "nus": "nus",
            "nv": "nv",
            "ny": "ny",
            "nyn": "nyn",
            "oc": "אקסיטאַניש",
            "om": "om",
            "or": "or",
            "os": "אסעטיש",
            "pa": "pa",
            "pcm": "pcm",
            "peo": "אַלט פּערסיש",
            "pl": "פּויליש",
            "prg": "פּרייסיש",
            "ps": "פּאַשטאָ",
            "pt": "פּארטוגעזיש",
            "pt-BR": "פּארטוגעזיש (בראַזיל)",
            "pt-PT": "פּארטוגעזיש (פּארטוגאַל)",
            "qu": "qu",
            "rhg": "rhg",
            "rm": "rm",
            "rn": "rn",
            "ro": "רומעניש",
            "ro-MD": "רומעניש (מאלדאווע)",
            "rof": "rof",
            "ru": "רוסיש",
            "rue": "רוסיניש",
            "rw": "rw",
            "rwk": "rwk",
            "sa": "סאַנסקריט",
            "sah": "sah",
            "saq": "saq",
            "sat": "sat",
            "sbp": "sbp",
            "sc": "סאַרדיש",
            "scn": "סיציליאַניש",
            "sco": "סקאטס",
            "sd": "סינדהי",
            "se": "נארדסאַמיש",
            "seh": "seh",
            "ses": "ses",
            "sg": "sg",
            "sga": "אַלט־איריש",
            "sh": "סערבא־קראאַטיש",
            "shi": "shi",
            "si": "סינהאַליש",
            "sk": "סלאוואַקיש",
            "sl": "סלאוועניש",
            "sli": "אונטער שלעזיש",
            "sm": "סאַמאאַניש",
            "smn": "smn",
            "sn": "שאנאַ",
            "so": "סאמאַליש",
            "sq": "אַלבאַניש",
            "sr": "סערביש",
            "st": "st",
            "su": "su",
            "sux": "סומעריש",
            "sv": "שוועדיש",
            "sw": "סוואַהיליש",
            "sw-CD": "קאנגא־סוואַהיליש",
            "swb": "קאמאריש",
            "szl": "שלעזיש",
            "ta": "טאַמיל",
            "te": "te",
            "teo": "teo",
            "tg": "tg",
            "th": "th",
            "ti": "ti",
            "tig": "טיגרע",
            "tk": "טורקמעניש",
            "tl": "טאַגאַלאג",
            "to": "to",
            "tr": "tr",
            "tt": "טאָטעריש",
            "twq": "twq",
            "tzm": "tzm",
            "ug": "ug",
            "uk": "אוקראַאיניש",
            "und": "אומבאַוואוסטע שפּראַך",
            "ur": "אורדו",
            "uz": "אוזבעקיש",
            "vai": "vai",
            "vi": "וויעטנאַמעזיש",
            "vls": "מערב פֿלעמיש",
            "vo": "וואלאַפּוק",
            "vun": "vun",
            "wae": "wae",
            "wo": "wo",
            "xh": "xh",
            "xog": "xog",
            "yav": "yav",
            "yi": "ייִדיש",
            "yo": "yo",
            "yrl": "yrl",
            "yue": "yue",
            "zgh": "zgh",
            "zh": "כינעזיש",
            "zh-Hans": "כינעזיש (Hans)",
            "zh-Hant": "כינעזיש (Hant)",
            "zu": "זולו",
            "zxx": "zxx"
          },
          "narrow": {
          },
          "short": {
            "az": "אַזערביידזשאַניש",
            "en-GB": "ענגליש (GB)",
            "en-US": "ענגליש (US)"
          }
        },
        "standard": {
          "long": {
            "aa": "אַפֿאַר",
            "ab": "ab",
            "af": "אַפֿריקאַנס",
            "agq": "agq",
            "ak": "ak",
            "akk": "אַקאַדיש",
            "am": "אַמהאַריש",
            "an": "אַראַגאניש",
            "ang": "אַלט ענגליש",
            "ar": "אַראַביש",
            "ar-001": "אַראַביש (וועלט)",
            "arc": "אַראַמיש",
            "as": "אַסאַמיש",
            "asa": "asa",
            "ast": "ast",
            "az": "אַזערביידזשאַניש",
            "ban": "באַלינעזיש",
            "bar": "בײַעריש",
            "bas": "bas",
            "be": "בעלאַרוסיש",
            "bem": "bem",
            "bez": "bez",
            "bg": "בולגאַריש",
            "bm": "bm",
            "bn": "בענגאַליש",
            "bo": "טיבעטיש",
            "br": "ברעטאניש",
            "brx": "brx",
            "bs": "באסניש",
            "ca": "קאַטאַלאניש",
            "ccp": "ccp",
            "ce": "ce",
            "ceb": "סעבואַניש",
            "cgg": "cgg",
            "chr": "chr",
            "ckb": "ckb",
            "co": "co",
            "crh": "קרים־טערקיש",
            "cs": "טשעכיש",
            "csb": "קאַשוביש",
            "cu": "קלויסטער־סלאַוויש",
            "cy": "וועלשיש",
            "da": "דעניש",
            "dav": "dav",
            "de": "דײַטש",
            "de-AT": "דײַטש (עסטרייך)",
            "de-CH": "דײַטש (שווייץ)",
            "dje": "dje",
            "doi": "doi",
            "dsb": "אונטער־סארביש",
            "dua": "dua",
            "dyo": "זשאלא־פֿאני",
            "dz": "dz",
            "ebu": "ebu",
            "ee": "ee",
            "el": "גריכיש",
            "en": "ענגליש",
            "en-AU": "ענגליש (אויסטראַליע)",
            "en-CA": "ענגליש (קאַנאַדע)",
            "en-GB": "ענגליש (פֿאַראייניגטע קעניגרייך)",
            "en-US": "ענגליש (פֿאַראייניגטע שטאַטן)",
            "enm": "מיטל ענגליש",
            "eo": "עספּעראַנטא",
            "es": "שפּאַניש",
            "es-419": "שפּאַניש (לאַטיין־אַמעריקע)",
            "es-ES": "שפּאַניש (שפּאַניע)",
            "es-MX": "שפּאַניש (מעקסיקע)",
            "et": "עסטיש",
            "eu": "באַסקיש",
            "ewo": "ewo",
            "fa": "פּערסיש",
            "fa-AF": "פּערסיש (אַפֿגהאַניסטאַן)",
            "ff": "ff",
            "fi": "פֿיניש",
            "fil": "פֿיליפּינא",
            "fj": "פֿידזשי",
            "fo": "פֿאַראיש",
            "fr": "פֿראַנצויזיש",
            "fr-CA": "פֿראַנצויזיש (קאַנאַדע)",
            "fr-CH": "פֿראַנצויזיש (שווייץ)",
            "frc": "frc",
            "fro": "אַלט־פֿראַנצויזיש",
            "frr": "דרום־פֿריזיש",
            "frs": "מזרח־פֿריזיש",
            "fur": "fur",
            "fy": "מערב־פֿריזיש",
            "ga": "איריש",
            "gd": "סקאטיש געליש",
            "gl": "גאַלישיש",
            "gmh": "מיטל הויכדויטש",
            "goh": "אַלט־ הויכדויטש",
            "got": "גאטיש",
            "grc": "אוראַלט־גריכיש",
            "gsw": "gsw",
            "gu": "gu",
            "guz": "guz",
            "gv": "מאַנקס",
            "ha": "האַוסאַ",
            "haw": "haw",
            "he": "העברעאיש",
            "hi": "הינדי",
            "hif": "פידזשי הינדי",
            "hmn": "hmn",
            "hr": "קראאַטיש",
            "hsb": "אייבער־סארביש",
            "ht": "ht",
            "hu": "אונגעריש",
            "hy": "אַרמעניש",
            "ia": "ia",
            "id": "אינדאנעזיש",
            "ig": "ig",
            "ii": "ii",
            "io": "אידא",
            "is": "איסלאַנדיש",
            "it": "איטאַליעניש",
            "ja": "יאַפּאַניש",
            "jbo": "לאזשבאָן",
            "jgo": "jgo",
            "jmc": "jmc",
            "jpr": "יידיש־פערסיש",
            "jv": "יאַוואַנעזיש",
            "ka": "גרוזיניש",
            "kab": "kab",
            "kam": "kam",
            "kde": "kde",
            "kea": "kea",
            "kgp": "kgp",
            "khq": "khq",
            "ki": "ki",
            "kk": "קאַזאַכיש",
            "kkj": "kkj",
            "kl": "kl",
            "kln": "kln",
            "km": "כמער",
            "kn": "קאַנאַדאַ",
            "ko": "קארעאיש",
            "kok": "kok",
            "ks": "ks",
            "ksb": "ksb",
            "ksf": "ksf",
            "ksh": "ksh",
            "ku": "קורדיש",
            "kw": "קארניש",
            "ky": "קירגיזיש",
            "la": "לאטייניש",
            "lad": "לאַדינא",
            "lag": "lag",
            "lb": "לוקסעמבורגיש",
            "lg": "lg",
            "lij": "lij",
            "liv": "ליוויש",
            "lkt": "lkt",
            "ln": "ln",
            "lo": "לאַא",
            "lou": "lou",
            "lrc": "lrc",
            "lt": "ליטוויש",
            "lu": "lu",
            "luo": "luo",
            "lus": "מיזא",
            "luy": "luy",
            "lv": "לעטיש",
            "mai": "mai",
            "mas": "mas",
            "mer": "mer",
            "mfe": "mfe",
            "mg": "mg",
            "mgh": "mgh",
            "mgo": "mgo",
            "mi": "מאַאריש",
            "mk": "מאַקעדאניש",
            "ml": "מאַלאַיאַלאַם",
            "mn": "מאנגאליש",
            "mni": "mni",
            "mr": "mr",
            "ms": "ms",
            "mt": "מאַלטעזיש",
            "mua": "mua",
            "mul": "mul",
            "my": "בירמאַניש",
            "mzn": "mzn",
            "nap": "נאַפּאליטַניש",
            "naq": "naq",
            "nb": "nb",
            "nd": "nd",
            "nds": "נידערדײַטש",
            "nds-NL": "נידערדײַטש (האלאַנד)",
            "ne": "נעפּאַליש",
            "nl": "האלענדיש",
            "nl-BE": "האלענדיש (בעלגיע)",
            "nmg": "nmg",
            "nn": "נײַ־נארוועגיש",
            "nnh": "nnh",
            "no": "נארוועגיש",
            "nus": "nus",
            "nv": "nv",
            "ny": "ny",
            "nyn": "nyn",
            "oc": "אקסיטאַניש",
            "om": "om",
            "or": "or",
            "os": "אסעטיש",
            "pa": "pa",
            "pcm": "pcm",
            "peo": "אַלט פּערסיש",
            "pl": "פּויליש",
            "prg": "פּרייסיש",
            "ps": "פּאַשטאָ",
            "pt": "פּארטוגעזיש",
            "pt-BR": "פּארטוגעזיש (בראַזיל)",
            "pt-PT": "פּארטוגעזיש (פּארטוגאַל)",
            "qu": "qu",
            "rhg": "rhg",
            "rm": "rm",
            "rn": "rn",
            "ro": "רומעניש",
            "ro-MD": "רומעניש (מאלדאווע)",
            "rof": "rof",
            "ru": "רוסיש",
            "rue": "רוסיניש",
            "rw": "rw",
            "rwk": "rwk",
            "sa": "סאַנסקריט",
            "sah": "sah",
            "saq": "saq",
            "sat": "sat",
            "sbp": "sbp",
            "sc": "סאַרדיש",
            "scn": "סיציליאַניש",
            "sco": "סקאטס",
            "sd": "סינדהי",
            "se": "נארדסאַמיש",
            "seh": "seh",
            "ses": "ses",
            "sg": "sg",
            "sga": "אַלט־איריש",
            "sh": "סערבא־קראאַטיש",
            "shi": "shi",
            "si": "סינהאַליש",
            "sk": "סלאוואַקיש",
            "sl": "סלאוועניש",
            "sli": "אונטער שלעזיש",
            "sm": "סאַמאאַניש",
            "smn": "smn",
            "sn": "שאנאַ",
            "so": "סאמאַליש",
            "sq": "אַלבאַניש",
            "sr": "סערביש",
            "st": "st",
            "su": "su",
            "sux": "סומעריש",
            "sv": "שוועדיש",
            "sw": "סוואַהיליש",
            "sw-CD": "סוואַהיליש (קאנגא־קינשאַזע)",
            "swb": "קאמאריש",
            "szl": "שלעזיש",
            "ta": "טאַמיל",
            "te": "te",
            "teo": "teo",
            "tg": "tg",
            "th": "th",
            "ti": "ti",
            "tig": "טיגרע",
            "tk": "טורקמעניש",
            "tl": "טאַגאַלאג",
            "to": "to",
            "tr": "tr",
            "tt": "טאָטעריש",
            "twq": "twq",
            "tzm": "tzm",
            "ug": "ug",
            "uk": "אוקראַאיניש",
            "und": "אומבאַוואוסטע שפּראַך",
            "ur": "אורדו",
            "uz": "אוזבעקיש",
            "vai": "vai",
            "vi": "וויעטנאַמעזיש",
            "vls": "מערב פֿלעמיש",
            "vo": "וואלאַפּוק",
            "vun": "vun",
            "wae": "wae",
            "wo": "wo",
            "xh": "xh",
            "xog": "xog",
            "yav": "yav",
            "yi": "ייִדיש",
            "yo": "yo",
            "yrl": "yrl",
            "yue": "yue",
            "zgh": "zgh",
            "zh": "כינעזיש",
            "zh-Hans": "כינעזיש (Hans)",
            "zh-Hant": "כינעזיש (Hant)",
            "zu": "זולו",
            "zxx": "zxx"
          },
          "narrow": {
          },
          "short": {
            "az": "אַזערביידזשאַניש",
            "en-GB": "ענגליש (פֿאַראייניגטע קעניגרייך)",
            "en-US": "ענגליש (פֿ\\\"ש)"
          }
        }
      },
      "region": {
        "long": {
          "001": "וועלט",
          "002": "אַפֿריקע",
          "003": "צפון־אַמעריקע",
          "005": "דרום־אַמעריקע",
          "009": "אקעאַניע",
          "011": "011",
          "013": "צענטראַל־אַמעריקע",
          "014": "014",
          "015": "015",
          "017": "017",
          "018": "018",
          "019": "אַמעריקע",
          "021": "צפונדיקע אַמעריקע",
          "029": "קאַראַאיבע",
          "030": "מזרח אַזיע",
          "034": "דרום־אַזיע",
          "035": "דרום־מזרח אַזיע",
          "039": "דרום־אייראפּע",
          "053": "053",
          "054": "054",
          "057": "057",
          "061": "פּאלינעזיע",
          "142": "אַזיע",
          "143": "צענטראַל־אַזיע",
          "145": "מערב־אַזיע",
          "150": "אייראפּע",
          "151": "מזרח־אייראפּע",
          "154": "צפֿון־אייראפּע",
          "155": "מערב־אייראפּע",
          "202": "202",
          "419": "לאַטיין־אַמעריקע",
          "AC": "AC",
          "AD": "אַנדארע",
          "AE": "AE",
          "AF": "אַפֿגהאַניסטאַן",
          "AG": "אַנטיגוע און באַרבודע",
          "AI": "AI",
          "AL": "אַלבאַניע",
          "AM": "אַרמעניע",
          "AO": "אַנגאלע",
          "AQ": "אַנטאַרקטיקע",
          "AR": "אַרגענטינע",
          "AS": "AS",
          "AT": "עסטרייך",
          "AU": "אויסטראַליע",
          "AW": "אַרובאַ",
          "AX": "AX",
          "AZ": "AZ",
          "BA": "באסניע הערצעגאווינע",
          "BB": "באַרבאַדאס",
          "BD": "באַנגלאַדעש",
          "BE": "בעלגיע",
          "BF": "בורקינע פֿאַסא",
          "BG": "בולגאַריע",
          "BH": "BH",
          "BI": "בורונדי",
          "BJ": "בענין",
          "BL": "BL",
          "BM": "בערמודע",
          "BN": "ברוניי",
          "BO": "באליוויע",
          "BQ": "BQ",
          "BR": "בראַזיל",
          "BS": "באַהאַמאַס",
          "BT": "בהוטאַן",
          "BV": "BV",
          "BW": "באצוואַנע",
          "BY": "בעלאַרוס",
          "BZ": "בעליז",
          "CA": "קאַנאַדע",
          "CC": "CC",
          "CD": "קאנגא־קינשאַזע",
          "CF": "צענטראַל־אַפֿריקאַנישע רעפּובליק",
          "CG": "CG",
          "CH": "שווייץ",
          "CI": "העלפֿאַ נדביין בארטן",
          "CK": "קוק אינזלען",
          "CL": "טשילע",
          "CM": "קאַמערון",
          "CN": "כינע",
          "CO": "קאלאמביע",
          "CP": "CP",
          "CR": "קאסטאַ ריקאַ",
          "CU": "קובאַ",
          "CV": "קאַפּווערדישע אינזלען",
          "CW": "קוראַסאַא",
          "CX": "CX",
          "CY": "CY",
          "CZ": "טשעכיי",
          "DE": "דייטשלאַנד",
          "DG": "DG",
          "DJ": "דזשיבוטי",
          "DK": "דענמאַרק",
          "DM": "דאמיניקע",
          "DO": "דאמיניקאַנישע רעפּובליק",
          "DZ": "DZ",
          "EA": "EA",
          "EC": "עקוואַדאר",
          "EE": "עסטלאַנד",
          "EG": "עגיפּטן",
          "EH": "EH",
          "ER": "עריטרעע",
          "ES": "שפּאַניע",
          "ET": "עטיאפּיע",
          "EU": "אייראפּעישער פֿאַרבאַנד",
          "EZ": "EZ",
          "FI": "פֿינלאַנד",
          "FJ": "פֿידזשי",
          "FK": "פֿאַלקלאַנד אינזלען",
          "FM": "מיקראנעזיע",
          "FO": "פֿאַרא אינזלען",
          "FR": "פֿראַנקרייך",
          "GA": "גאַבאן",
          "GB": "פֿאַראייניגטע קעניגרייך",
          "GD": "גרענאַדאַ",
          "GE": "גרוזיע",
          "GF": "פֿראַנצויזישע גויאַנע",
          "GG": "גערנזי",
          "GH": "גהאַנע",
          "GI": "גיבראַלטאַר",
          "GL": "גרינלאַנד",
          "GM": "גאַמביע",
          "GN": "גינע",
          "GP": "גוואַדעלופ",
          "GQ": "עקוואַטארישע גינע",
          "GR": "גריכנלאַנד",
          "GS": "GS",
          "GT": "גוואַטעמאַלע",
          "GU": "גוואַם",
          "GW": "גינע־ביסאַו",
          "GY": "גויאַנע",
          "HK": "HK",
          "HM": "HM",
          "HN": "האנדוראַס",
          "HR": "קראאַטיע",
          "HT": "האַיטי",
          "HU": "אונגערן",
          "IC": "קאַנאַרישע אינזלען",
          "ID": "אינדאנעזיע",
          "IE": "אירלאַנד",
          "IL": "ישראל",
          "IM": "IM",
          "IN": "אינדיע",
          "IO": "IO",
          "IQ": "IQ",
          "IR": "איראַן",
          "IS": "איסלאַנד",
          "IT": "איטאַליע",
          "JE": "דזשערזי",
          "JM": "דזשאַמייקע",
          "JO": "JO",
          "JP": "יאַפּאַן",
          "KE": "קעניע",
          "KG": "KG",
          "KH": "קאַמבאדיע",
          "KI": "קיריבאַטי",
          "KM": "קאמאראס",
          "KN": "KN",
          "KP": "KP",
          "KR": "KR",
          "KW": "KW",
          "KY": "קיימאַן אינזלען",
          "KZ": "KZ",
          "LA": "לאַאס",
          "LB": "לבנון",
          "LC": "LC",
          "LI": "ליכטנשטיין",
          "LK": "סרי־לאַנקאַ",
          "LR": "ליבעריע",
          "LS": "לעסאטא",
          "LT": "ליטע",
          "LU": "לוקסעמבורג",
          "LV": "לעטלאַנד",
          "LY": "ליביע",
          "MA": "מאַראקא",
          "MC": "מאנאַקא",
          "MD": "מאלדאווע",
          "ME": "מאנטענעגרא",
          "MF": "MF",
          "MG": "מאַדאַגאַסקאַר",
          "MH": "מאַרשאַל אינזלען",
          "MK": "MK",
          "ML": "מאַלי",
          "MM": "מיאַנמאַר",
          "MN": "מאנגאליי",
          "MO": "MO",
          "MP": "MP",
          "MQ": "מאַרטיניק",
          "MR": "מאַריטאַניע",
          "MS": "מאנטסעראַט",
          "MT": "מאַלטאַ",
          "MU": "מאריציוס",
          "MV": "מאַלדיוון",
          "MW": "מאַלאַווי",
          "MX": "מעקסיקע",
          "MY": "מאַלייזיע",
          "MZ": "מאזאַמביק",
          "NA": "נאַמיביע",
          "NC": "נײַ קאַלעדאניע",
          "NE": "ניזשער",
          "NF": "נארפֿאלק אינזל",
          "NG": "ניגעריע",
          "NI": "ניקאַראַגוע",
          "NL": "האלאַנד",
          "NO": "נארוועגיע",
          "NP": "נעפּאַל",
          "NR": "NR",
          "NU": "NU",
          "NZ": "ניו זילאַנד",
          "OM": "OM",
          "PA": "פּאַנאַמאַ",
          "PE": "פּערו",
          "PF": "פֿראַנצויזישע פּאלינעזיע",
          "PG": "פּאַפּואַ נײַ גינע",
          "PH": "פֿיליפּינען",
          "PK": "פּאַקיסטאַן",
          "PL": "פּוילן",
          "PM": "PM",
          "PN": "פּיטקערן אינזלען",
          "PR": "פּארטא־ריקא",
          "PS": "PS",
          "PT": "פּארטוגאַל",
          "PW": "PW",
          "PY": "פּאַראַגווײַ",
          "QA": "קאַטאַר",
          "QO": "QO",
          "RE": "רעאוניאן",
          "RO": "רומעניע",
          "RS": "סערביע",
          "RU": "רוסלאַנד",
          "RW": "רוואַנדע",
          "SA": "SA",
          "SB": "סאלאמאן אינזלען",
          "SC": "סיישעל",
          "SD": "סודאַן",
          "SE": "שוועדן",
          "SG": "סינגאַפּור",
          "SH": "סט העלענע",
          "SI": "סלאוועניע",
          "SJ": "SJ",
          "SK": "סלאוואַקיי",
          "SL": "סיערע לעאנע",
          "SM": "סאַן מאַרינא",
          "SN": "סענעגאַל",
          "SO": "סאמאַליע",
          "SR": "סורינאַם",
          "SS": "דרום־סודאַן",
          "ST": "סאַא טאמע און פּרינסיפּע",
          "SV": "על סאַלוואַדאר",
          "SX": "SX",
          "SY": "סיריע",
          "SZ": "סוואַזילאַנד",
          "TA": "TA",
          "TC": "TC",
          "TD": "טשאַד",
          "TF": "TF",
          "TG": "טאגא",
          "TH": "טיילאַנד",
          "TJ": "TJ",
          "TK": "TK",
          "TL": "TL",
          "TM": "טורקמעניסטאַן",
          "TN": "טוניסיע",
          "TO": "טאנגאַ",
          "TR": "טערקיי",
          "TT": "טרינידאַד און טאבאַגא",
          "TV": "טואוואַלו",
          "TW": "TW",
          "TZ": "טאַנזאַניע",
          "UA": "אוקראַינע",
          "UG": "אוגאַנדע",
          "UM": "UM",
          "UN": "UN",
          "US": "פֿאַראייניגטע שטאַטן",
          "UY": "אורוגוויי",
          "UZ": "UZ",
          "VA": "וואַטיקאַן שטאָט",
          "VC": "VC",
          "VE": "ווענעזועלע",
          "VG": "VG",
          "VI": "VI",
          "VN": "וויעטנאַם",
          "VU": "וואַנואַטו",
          "WF": "WF",
          "WS": "סאַמאאַ",
          "XA": "XA",
          "XB": "XB",
          "XK": "קאסאווא",
          "YE": "תימן",
          "YT": "מאַיאט",
          "ZA": "דרום־אַפֿריקע",
          "ZM": "זאַמביע",
          "ZW": "זימבאַבווע",
          "ZZ": "אומבאַוואוסטער ראַיאן"
        },
        "narrow": {
        },
        "short": {
          "GB": "פֿאַראייניגטע קעניגרייך",
          "HK": "HK",
          "MO": "MO",
          "PS": "PS",
          "US": "פֿ\\\"ש"
        }
      },
      "script": {
        "long": {
          "Adlm": "Adlm",
          "Aghb": "Aghb",
          "Ahom": "Ahom",
          "Arab": "אַראַביש",
          "Aran": "Aran",
          "Armi": "Armi",
          "Armn": "Armn",
          "Avst": "Avst",
          "Bali": "Bali",
          "Bamu": "Bamu",
          "Bass": "Bass",
          "Batk": "Batk",
          "Beng": "Beng",
          "Bhks": "Bhks",
          "Bopo": "Bopo",
          "Brah": "Brah",
          "Brai": "Brai",
          "Bugi": "Bugi",
          "Buhd": "Buhd",
          "Cakm": "Cakm",
          "Cans": "Cans",
          "Cari": "Cari",
          "Cham": "Cham",
          "Cher": "Cher",
          "Chrs": "Chrs",
          "Copt": "Copt",
          "Cpmn": "Cpmn",
          "Cprt": "Cprt",
          "Cyrl": "ציריליש",
          "Deva": "דעוואַנאַגאַרי",
          "Diak": "Diak",
          "Dogr": "Dogr",
          "Dsrt": "Dsrt",
          "Dupl": "Dupl",
          "Egyp": "Egyp",
          "Elba": "Elba",
          "Elym": "Elym",
          "Ethi": "Ethi",
          "Geor": "Geor",
          "Glag": "Glag",
          "Gong": "Gong",
          "Gonm": "Gonm",
          "Goth": "Goth",
          "Gran": "Gran",
          "Grek": "גריכיש",
          "Gujr": "Gujr",
          "Guru": "Guru",
          "Hanb": "Hanb",
          "Hang": "Hang",
          "Hani": "Hani",
          "Hano": "Hano",
          "Hans": "Hans",
          "Hant": "Hant",
          "Hatr": "Hatr",
          "Hebr": "העברעיש",
          "Hira": "Hira",
          "Hluw": "Hluw",
          "Hmng": "Hmng",
          "Hmnp": "Hmnp",
          "Hrkt": "Hrkt",
          "Hung": "Hung",
          "Ital": "Ital",
          "Jamo": "Jamo",
          "Java": "Java",
          "Jpan": "Jpan",
          "Kali": "Kali",
          "Kana": "Kana",
          "Khar": "Khar",
          "Khmr": "Khmr",
          "Khoj": "Khoj",
          "Kits": "Kits",
          "Knda": "Knda",
          "Kore": "Kore",
          "Kthi": "Kthi",
          "Lana": "Lana",
          "Laoo": "Laoo",
          "Latn": "גַלחיש",
          "Lepc": "Lepc",
          "Limb": "Limb",
          "Lina": "Lina",
          "Linb": "Linb",
          "Lisu": "Lisu",
          "Lyci": "Lyci",
          "Lydi": "Lydi",
          "Mahj": "Mahj",
          "Maka": "Maka",
          "Mand": "Mand",
          "Mani": "Mani",
          "Marc": "Marc",
          "Medf": "Medf",
          "Mend": "Mend",
          "Merc": "Merc",
          "Mero": "Mero",
          "Mlym": "Mlym",
          "Modi": "Modi",
          "Mong": "Mong",
          "Mroo": "Mroo",
          "Mtei": "Mtei",
          "Mult": "Mult",
          "Mymr": "Mymr",
          "Nand": "Nand",
          "Narb": "Narb",
          "Nbat": "Nbat",
          "Newa": "Newa",
          "Nkoo": "Nkoo",
          "Nshu": "Nshu",
          "Ogam": "Ogam",
          "Olck": "Olck",
          "Orkh": "Orkh",
          "Orya": "Orya",
          "Osge": "Osge",
          "Osma": "Osma",
          "Ougr": "Ougr",
          "Palm": "Palm",
          "Pauc": "Pauc",
          "Perm": "Perm",
          "Phag": "Phag",
          "Phli": "Phli",
          "Phlp": "Phlp",
          "Phnx": "Phnx",
          "Plrd": "Plrd",
          "Prti": "Prti",
          "Qaag": "Qaag",
          "Rjng": "Rjng",
          "Rohg": "Rohg",
          "Runr": "Runr",
          "Samr": "Samr",
          "Sarb": "Sarb",
          "Saur": "Saur",
          "Sgnw": "Sgnw",
          "Shaw": "Shaw",
          "Shrd": "Shrd",
          "Sidd": "Sidd",
          "Sind": "Sind",
          "Sinh": "Sinh",
          "Sogd": "Sogd",
          "Sogo": "Sogo",
          "Sora": "Sora",
          "Soyo": "Soyo",
          "Sund": "Sund",
          "Sylo": "Sylo",
          "Syrc": "Syrc",
          "Tagb": "Tagb",
          "Takr": "Takr",
          "Tale": "Tale",
          "Talu": "Talu",
          "Taml": "Taml",
          "Tang": "Tang",
          "Tavt": "Tavt",
          "Telu": "Telu",
          "Tfng": "Tfng",
          "Tglg": "Tglg",
          "Thaa": "Thaa",
          "Thai": "Thai",
          "Tibt": "Tibt",
          "Tirh": "Tirh",
          "Tnsa": "Tnsa",
          "Toto": "Toto",
          "Ugar": "Ugar",
          "Vaii": "Vaii",
          "Vith": "Vith",
          "Wara": "Wara",
          "Wcho": "Wcho",
          "Xpeo": "Xpeo",
          "Xsux": "Xsux",
          "Yezi": "Yezi",
          "Yiii": "Yiii",
          "Zanb": "Zanb",
          "Zinh": "Zinh",
          "Zmth": "Zmth",
          "Zsye": "Zsye",
          "Zsym": "Zsym",
          "Zxxx": "Zxxx",
          "Zyyy": "Zyyy",
          "Zzzz": "Zzzz"
        },
        "narrow": {
        },
        "short": {
        }
      }
    }
  },
  "locale": "yi"
})
}